import { Component, Input } from '@angular/core';

export interface BarListRow {
  label: string;
  value: number;
  displayValue?: string;
}

@Component({
  selector: 'app-bar-list',
  standalone: false,
  templateUrl: './bar-list.html',
})
export class BarList {
  @Input() rows: BarListRow[] = [];
  @Input() labelWidth = '90px';

  barPct(row: BarListRow): number {
    const max = Math.max(...this.rows.map(r => r.value), 1);
    return Math.round((row.value / max) * 100);
  }
}
